import { LANGS, getLang, setLang, useT } from "../lib/i18n";

export default function LangSwitch({ className = "" }) {
  useT();
  return (
    <div className={`inline-flex gap-1 text-xs ${className}`} data-testid="lang-switch">
      {Object.entries(LANGS).map(([k, v]) => <button key={k} onClick={() => setLang(k)} data-testid={`lang-${k}`} className={`px-2 py-1 rounded border ${getLang() === k ? "bg-blue-600 text-white border-blue-600" : "border-slate-200 text-slate-600 bg-white"}`}>{v}</button>)}
    </div>
  );
}
